export default function noAnimationResize() {
  var timer = 0;
  if (window.innerWidth < 1024) {
    $('body').addClass('resizing');
  } else {
    $('body').removeClass('resizing');
  }

  if (timer) {
    clearTimeout(timer);
  }

  window.timer = setTimeout(function () {
    $("body").removeClass("resizing");
  }, 500);
}